import React, { useState, useContext } from 'react'
import { Trans } from '@lingui/macro'
import { Box } from '@chakra-ui/react'

import Table, { TableBody } from '../../../components/common/table/Table'
import { ButtonPrimary } from 'front-end/src/components'
import { NewCertificateItemModal } from './NewCertificateItemModal'
import IconPlus2 from '../../../components/common/icon/IconPlus2'
import { ManageCertificationItem } from './ManageCertificationItem'
import { ManageCertificationPageContext } from './ManageCertificationPage'
import IconLock from '../../../components/common/icon/IconLock'
import Message, {
  MessageTypes
} from '../../../components/common/message/Message'
import { PagePanel } from 'front-end/src/components/common/page/Page'

export const CertificationSetup = () => {
  const { certification } = useContext(ManageCertificationPageContext)
  const [showModal, setShowModal] = useState(false)

  return (
    <PagePanel>
      {!!certification.locked_at && (
        <Box mb="48px">
          <Message className="Message__lockedIcon" type={MessageTypes.WARNING}>
            <div className="Icon__wrapper">
              <IconLock />
            </div>
            <div className="Text_wrapper">
              <Trans>
                This certification has been locked, and cannot be edited
                anymore.
              </Trans>
            </div>
          </Message>
        </Box>
      )}

      <h3>
        <Trans>Requirements</Trans>
      </h3>
      <Table css={{ marginTop: 12 }}>
        <TableBody>
          {certification.items?.map((item, index) => {
            return (
              <ManageCertificationItem
                key={index}
                locked={!!certification.locked_at}
                item={item}
                first={index === 0}
                last={index === certification.items.length - 1}
              />
            )
          })}
        </TableBody>
      </Table>
      {!certification.locked_at && (
        <Box mt="8" textAlign="center">
          <ButtonPrimary
            onClick={() => setShowModal(true)}
            leftIcon={<IconPlus2 />}
          >
            <Trans>Add into certification</Trans>
          </ButtonPrimary>
        </Box>
      )}

      <NewCertificateItemModal
        show={showModal}
        onClose={() => setShowModal(false)}
      />
    </PagePanel>
  )
}
